// extracted by mini-css-extract-plugin
export default {"container":"ej-z"};